<template>
  <v-app class="theme--dark" v-show="value && showDialog">
    <div v-if="showDialog">
      <v-dialog persistent :value="value" max-width="500px">
        <v-card>
          <v-toolbar dense class="">
            <v-toolbar-title>Update Submission Date</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
            <!-- Popup content -->
            <v-card>
              <v-card-text>
                  <!-- <v-text-field
                    prepend-icon="email"
                    type="email"
                    v-model="email"
                    :error-messages="emailErrors"
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
                  ></v-text-field> -->
                  <v-row>
                    <v-col cols="12">
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        max-width="290"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="submissionDateFormatted"
                            label=""
                            prepend-icon="mdi-calendar"
                            hint="DD/MM/YYYY format"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="submissionDate"
                          @change="menu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
              </v-card-text>
              <!-- Footer -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeModal"> Close </v-btn>
                <v-btn class="success" @click="updateSubmission">Update</v-btn>
              </v-card-actions>
            </v-card>
        </v-card>
      </v-dialog>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        loader="bars"
        background-color="#000"
        color="secondary"
        width.number="90"
        height.number="90"
      />
    </div>
  </v-app>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate';
import pairingAPIs from '../../Pairing/pairingAPIs';
// import influencerAPIs from '../../Influencer/influencerAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'UpdateSubmissionDateModal',
  props: {
    value: Boolean,
    pairing: Object
  },
  components: {
    Loading
  },
  mixins: [validationMixin],
  data () {
    return {
      submissionDate: '',
      menu: '',
      isLoading: false,
      showDialog: false
    }
  },
  validations: {
    email: {
      required
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push('Email is required');
      return errors;
    },
    submissionDateFormatted() {
      return this.submissionDate ? moment(this.submissionDate).format('DD/MM/yyyy') : ''
    }
  },
  watch: {
    pairing(value) {
      this.showDialog = true
      if (value.pairing_details) {
        if (value.pairing_details.submission_date) {
          this.submissionDate = moment(value.pairing_details.submission_date).format('YYYY-MM-DD')
        }
      }
    }
  },
  methods: {
    async updateSubmission() {
      if (!this.submissionDate) {
        this.$swal({
          type: 'warning',
          title: `Invalid Submission Date`,
          text: 'Make sure you filled the date correctly.'
        });
        return;
      }
      this.isLoading = true;
      // update pairings
      let formData = new FormData();
      formData.append('pairingID', this.pairing.id);
      formData.append('submissionDate', this.submissionDate);
      let resp = await pairingAPIs.updateSubmissionDate(formData)
      this.isLoading = false;
      if (!resp.status) {
        this.$swal({
          text: 'Error updating submission date.',
          type: 'error'
        });
        return
      }
      // Show success message
      this.$swal({
        text: 'Successfully updated Submission Date.',
        type: 'success'
      });
      this.$emit('updated')
      this.closeModal()
    },
    closeModal: function () {
      this.showDialog = false
      this.$emit('input')
      this.$emit('closeModal')
      this.submissionDate = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpdateSubmissionDateModal.vue?1488ac69